module.exports = __webpack_public_path__ + "static/media/loader-v2.741c61dc.gif";